<template>
  <div class="container-fluid mt-3">
    <form @submit.prevent="updatePrice" >
      <div class="row">
        <div class="col-md-6 col-sm-12">

          <div class="form-group" v-if="errors.length" >
            <ul class="list-group">
              <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>

          <div class="form-group input-group-sm">
            <label>Nazwa produktu</label>
            <input type="text"
              class="form-control mb-3"
              placeholder="Szukaj"
              v-model="searchFilter"
              @keyup="onFilterChange">
            <select multiple class="form-control select-size" v-model="selectedProductNames" style="height:200px">
              <option v-for="option in productNames" :key="option" v-bind:value="option" >
                {{ option }}
              </option>
            </select>
          </div>

          <div class="form-group input-group-sm">
            <label >Sklepy</label>
            <select multiple class="form-control select-size" v-model="selectedStores">
              <option v-for="option in stores" :key="option.id" v-bind:value="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>

          <div class="form-group input-group-sm">
            <label>Nowa cena</label>
            <input class="form-control" type="text" v-model="productPrice">
          </div>

          <div class="form-group input-group-sm">
            <input class="btn btn-success btn-sm mr-2 torre-btn" type="submit" value="Zapisz">
          </div>

        </div>
      </div>
    </form>
  </div>
</template>
<script>
import autoComplete from "js-autocomplete"
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import MainPresenter from "@/service/MainPresenter"
import validator from 'validator'
import un from 'underscore'
import uns from "underscore.string"
import priceUtils from "@/utils/PriceUtils"

export default {
  name: "",
  data: () => ({
    mainPresenter: new MainPresenter(),
    searchFilter:"",
    errors: [],
    allOption: [{id: -1, name: "wszystkie"}],
    stores:[],
    productNames: [],
    productNamesCpy: [],
    selectedStores: [],
    productPrice: 0,
    selectedProductNames: [],
    updateProductData: {
      price: 0,
      productName: "",
      categories: [],
      color: null,
      brands: [],
      stores: []
    },
  }),
  created() {
    this.loadStores();
  },
  mounted() {
    this.loadProductNames();
  },
  methods: {
    filterNames: function () {
      if (validator.isEmpty(this.searchFilter)) {
        this.productNames = this.productNamesCpy;
        return;
      }
      this.productNames = un.filter(this.productNamesCpy, item => {
        return uns.include(item.toLowerCase(), this.searchFilter.toLowerCase());
      });
    },
    onFilterChange: un.debounce(function (e) {
      this.filterNames();
    }, 150),
    updatePrice: function() {
      this.errors = []
      var err = this.validate()
      if (err.length > 0) {
        this.errors = err
        return false
      }
      this.updateProductData.productName = this.selectedProductNames[0]
      this.updateProductData.price = priceUtils.convertToDouble(this.productPrice)
      this.updateProductData.stores = this.getStores()

      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/updateProductsPrice',
        data: this.updateProductData,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.$router.push({name: 'main'})
      }).catch(e => {
        console.log("errore updating ");
      })

    },
    validate () {
      var err = []
      var pn = this.selectedProductNames[0] || ""

      if (validator.isEmpty(pn)) {
        err.push('Podaj nazwe produktu')
      }
      if (!un.contains(this.productNames, pn)) {
        err.push('Nie ma takiej nazwy produktu')
      }
      if (this.selectedStores.length === 0){
        err.push('Wybierz sklep')
      }
      if (this.selectedStores.length > 1){
        var el = un.find(this.selectedStores, function(el) {
          return el === -1
        })
        if (el === -1) {
          err.push('Niepoprawna konfiguracja sklepów')
        }
      }
      var price = priceUtils.convertToDouble(this.productPrice)
      if (!un.isNumber(price)) {
        err.push('Podaj poprawną liczbę ceny')
      }
      if (price <= 0 ){
        err.push('Cena ma być większa od zera')
      }
      return err
    },
    getStores: function() {
      var el = un.find(this.selectedStores, function(el) {
        return el === -1
      })
      if (el === -1) {
        return []
      }
      return this.selectedStores
    },
    loadStores: function() {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + '/stores?sort=name',
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.stores = this.allOption.concat(res.data._embedded.stores)
      }).catch(_ => {
        console.log('blad stores')
      })
    },
    loadProductNames: function () {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + "/product/allNames",
        headers: {
          Authorization: userService.getAuthHeader()
        }
      });
      req.then(res => {
        this.productNames = res.data
        this.productNamesCpy = res.data
      }).catch(_ => {
        console.log("err");
      })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/product-prices/EditProductPrices.vue